import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-tls-dialog',
  templateUrl: './tls-dialog.component.html',
  styleUrls: ['./tls-dialog.component.css']
})
export class TlsDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<TlsDialogComponent>,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: {heading: string,case: number}
  ) { }

  ngOnInit(): void {
  }
  nav(url:string){
    this.dialogRef.close(true)
    this.router.navigate(['/'+url])

  }
  confirm(){
    this.dialogRef.close(true)
  }
  cancel(){
    this.dialogRef.close()
  }

}
